import { render, staticRenderFns } from "./SkillCardResultModal.vue?vue&type=template&id=482be456&scoped=true&"
import script from "./SkillCardResultModal.vue?vue&type=script&lang=js&"
export * from "./SkillCardResultModal.vue?vue&type=script&lang=js&"
import style0 from "./SkillCardResultModal.vue?vue&type=style&index=0&id=482be456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482be456",
  null
  
)

export default component.exports